import React from 'react'
import PDIComponent from '../pdi/PDIComponent'

export const HasarlidanCikis = () => {
    return <PDIComponent title="Hasarlıdan Çıkış" defaultRadio="Hasarlıdan Çıkış" showSwitch={true} api="/hasarlidan-cikis" modalArea="Hasarlıdan Çıkış" />
}
